import React, {useState} from 'react'
import {Form, Input, Modal, Button} from "antd";
import {createDepartment} from "../../services/serviceDepartment";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input

const DepartmentCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])

    const formLayout = {
        labelCol: {span: 8},
        wrapperCol: {span: 16}
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.deptName,
            code: list.deptCode,
            description: list.deptDescription
        }
        createDepartment(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
            open={show}
            closable={false}
            title={'Yeni Departman Ekle'}
            footer={[
                <Button key={'Submit Button'} type={'primary'} loading={loadings[0]} onClick={() => form.submit()}>
                    Kaydet
                </Button>,
                <Button key={'Cancel Button'} onClick={() => modalCloser()}>
                    Kapat
                </Button>
            ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Departman Adı'}
                        name={'deptName'}
                        rules={[
                            {required:true, message: 'Departman Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Departman Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Departmand Kodu'}
                        name={'deptCode'}
                        rules={[
                            {required: true, message: 'Departman Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Departman Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Departman Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                    label={'Departman Açıklaması'}
                    name={'deptDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default DepartmentCreate